import { props, state } from 'cerebral/tags'
import { when } from 'cerebral/operators'
import isAdmin from 'utils/isAdmin'
import showDialog from 'modules/App/factories/showDialog'
import determineView from '../actions/determineView'

const constructDialog = [
  when(state`media.showDetail`),
  {
    true: [
      function() {
        return {
          signal: 'media.onDeleteFileInDetailedView'
        }
      }
    ],
    false: [
      function() {
        return {
          signal: 'media.onDeleteSelectedFiles'
        }
      }
    ]
  },
  showDialog({
    type: 'confirm',
    title: {
      key: 'bms.media.dialog.deleteFiles.title'
    },
    content: {
      key: 'bms.media.dialog.deleteFiles.content',
      params: {
        count: props`count`
      }
    },
    confirm: {
      signal: props`signal`,
      args: {}
    }
  })
]

export default [
  when(
    state`app.user.group`,
    state`media.selectedFiles`,
    (group, files) => isAdmin(group) && files.length
  ),
  {
    true: [
      ({ state }) => ({ count: state.get('media.selectedFiles').length }),
      determineView,
      {
        detailedView: [() => ({ count: 1 }), ...constructDialog],
        mediaView: [
          function({ state }) {
            return {
              count: state.get('media.selectedFiles').length
            }
          },
          ...constructDialog
        ],
        other: []
      }
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/askDeleteFiles.js